import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageWorkingProcess,
  DeleteWorkingProcess,
  EditWorkingProcess,
  GetCountries,
  GetGroups,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { GetWorkingProcess } from "./actions";

const WorkingProcess = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);

  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  const Schema = Yup.object().shape({
    type: Yup.string().trim().required("required"),
    text: Yup.string().trim().required("required"),
    description: Yup.string().trim().required("required"),
    order_number: Yup.string().trim().required("required"),
  });

  let groups = [];
  console.log({ auihfajlfaf: groups });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetWorkingProcess({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
          } else {
            setData([]);
          }
          setLoadingData(false);

          dispatch(
            GetGroups({
              callback: (data) => {
                if (isValidArray(data?.data)) {
                  const updatedData = [
                    ...data?.data,
                    {
                      id: "-",
                      group_name: "-",
                      nationality_id: null,
                      is_deleted: 0,
                      is_active: 1,
                      created_date: null,
                      type_id: null,
                      type_name: "-",
                      nationality_name: "-",
                    },
                  ];

                  groups = updatedData;
                }

                if (array.length == 0) {
                  dispatch(
                    GetCountries({
                      callback: (Country) => {
                        setarray([
                          {
                            failed: "id",
                            type: inputType.text,
                            title: "id",
                            placeholder: "",
                            fullwidth: true,
                            customdesign: { display: "none" },
                          },

                          {
                            failed: "type",
                            type: inputType.dropdownSearch,
                            datadropdown: [
                              {
                                id: "success",
                                name: "Success",
                              },
                              {
                                id: "reject",
                                name: "Reject",
                              },
                            ],
                            faileddropdown: {
                              name: "name",
                              value: "id",
                            },
                            title: "Type",
                            placeholder: "",
                            fullwidth: true,
                          },
                          {
                            failed: "image",
                            type: inputType.image,
                            title: "Image",
                            placeholder: "",
                            fullwidth: true,
                          },
                          {
                            failed: "text",
                            type: inputType.text,
                            title: "Text",
                            placeholder: "",
                            fullwidth: true,
                          },
                          {
                            failed: "order_number",
                            type: inputType.number,
                            title: "Order Number",
                            placeholder: "",
                            fullwidth: true,
                          },
                          {
                            failed: "description",
                            type: inputType.text,
                            title: "Description",
                            placeholder: "",
                            fullwidth: true,
                          },
                        ]);
                      },
                    })
                  );
                }
              },
            })
          );
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "type" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "text" },
    { type: columntype.text, name: "description" },
    { type: columntype.switch, name: "is_main" },
    { type: columntype.switch, name: "is_active" },
  ];
  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: true,
    },
    {
      id: "type",
      numeric: false,
      disablePadding: false,
      label: "Type",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "text",
      numeric: false,
      disablePadding: false,
      label: "Text",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "is_main",
      numeric: false,
      disablePadding: false,
      label: "Is main",
      withSort: true,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    (dataPrivileges["16"]?.access_edit == 1 ||
      dataPrivileges["16"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];
  const List = [
    dataPrivileges["16"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.username ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteWorkingProcess({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["3"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditWorkingProcess({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteWorkingProcess({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["16"]?.access_write == 1 ? true : false}
        withDeleteItem={dataPrivileges["16"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["16"]?.access_edit == 1 ? true : false}
        withPagination={false}
        withSearch={false}
        nameTable={`Working Process`}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Working process"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new Working process"}
          buttonTitle={editMode ? "Edit" : "Add"}
          // onChange={({ value, failedName, setFieldValue }) => {
          //   console.log({ value123: value });
          //   if (failedName == "group_id" && value == "-") {
          // setarray([
          //                 {
          //                   failed: "id",
          //                   type: inputType.text,
          //                   title: "id",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                   customdesign: { display: "none" },
          //                 },
          //                 {
          //                   failed: "country_id",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: Country.data,
          //                   faileddropdown: {
          //                     name: "name",
          //                     value: "id",
          //                   },
          //                   title: "Country",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "type",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: [
          //                     {
          //                       id: "success",
          //                       name: "Success",
          //                     },
          //                     {
          //                       id: "reject",
          //                       name: "Reject",
          //                     },
          //                   ],
          //                   faileddropdown: {
          //                     name: "name",
          //                     value: "id",
          //                   },
          //                   title: "Type",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "image",
          //                   type: inputType.image,
          //                   title: "Image",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "text",
          //                   type: inputType.text,
          //                   title: "Text",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "order_number",
          //                   type: inputType.number,
          //                   title: "Order Number",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "description",
          //                   type: inputType.text,
          //                   title: "Description",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "group_id",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: groups,
          //                   faileddropdown: {
          //                     name: "group_name",
          //                     value: "id",
          //                   },
          //                   title: "Group",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //               ]);
          //   } else {
          //   setarray([
          //                 {
          //                   failed: "id",
          //                   type: inputType.text,
          //                   title: "id",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                   customdesign: { display: "none" },
          //                 },
          //                 {
          //                   failed: "country_id",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: Country.data,
          //                   faileddropdown: {
          //                     name: "name",
          //                     value: "id",
          //                   },
          //                   title: "Country",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "type",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: [
          //                     {
          //                       id: "success",
          //                       name: "Success",
          //                     },
          //                     {
          //                       id: "reject",
          //                       name: "Reject",
          //                     },
          //                   ],
          //                   faileddropdown: {
          //                     name: "name",
          //                     value: "id",
          //                   },
          //                   title: "Type",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "image",
          //                   type: inputType.image,
          //                   title: "Image",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "text",
          //                   type: inputType.text,
          //                   title: "Text",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "order_number",
          //                   type: inputType.number,
          //                   title: "Order Number",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "description",
          //                   type: inputType.text,
          //                   title: "Description",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //                 {
          //                   failed: "group_id",
          //                   type: inputType.dropdownSearch,
          //                   datadropdown: groups,
          //                   faileddropdown: {
          //                     name: "group_name",
          //                     value: "id",
          //                   },
          //                   title: "Group",
          //                   placeholder: "",
          //                   fullwidth: true,
          //                 },
          //               ]);
          //   }
          // }}
          onSubmit={(valuess) => {
            dispatch(
              ManageWorkingProcess({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default WorkingProcess;
